<template>
  <div class="project">
    <div style="width: 1200px; margin: 0 auto">
      <div style="width: 100%; height: 50px"></div>
      <div
        style="
          line-height: 26px;
          font-size: 26px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #000000;
        "
      >
        项目库<span
          style="
            line-height: 18px;
            font-size: 18px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
            margin-left: 10px;
          "
          >Project&nbsp;Library</span
        >
      </div>
      <div
        style="width: 54px; height: 2px; background: #3476c1; margin-top: 20px"
      ></div>
      <div
        style="
          width: 1200px;
          margin: 30px auto 0;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <div
          class="project-i"
          @click="toDetail(item.id)"
          v-for="(item, index) in list"
          :key="index"
        >
          <div style="width: 285px; height: 200px;overflow:hidden">
            <img
            class="hover"
              :src="item.projectImg"
              alt=""
              style="width: 100%; display: block"
            />
          </div>
          <div class="project-i-t">{{ item.name }}</div>
          <div class="project-i-txt">{{ item.remark }}</div>
        </div>
        <div v-for="(item, index) in jiaArr" :key="index + 100" style="width: 285px; height: 200px"></div>
      </div>
      <div style="clear: both"></div>
      <div class="morezanserve" @click="toMore">更多项目</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "project",
  data() {
    return {
      list: [],
      jiaArr: []
    };
  },
  created() {
    this.$axios.get("/v1/cloud/common/project/home", {}).then(({ data }) => {
      if (data) {
        data.forEach(function (item, index) {
          item.remark = item.remark.substr(0, 34) + "...";
        });
        this.list = data;
        this.jiaArr = data.length < 8 ? 8 - data.length : 0
      }
    });
  },
  mounted() {
    //修改dom元素
    // this.timer = setTimeout(()=> {
    //     var domList = document.querySelectorAll(".project-i-txt");
    //     var newList = Array.from(domList);
    //     newList.forEach((item,index,array)=>{
    //         console.log(66666,domList[index].innerText);
    //         var str = domList[index].innerText;
    //         str = str.substr(0,34) + '...' ;
    //         domList[index].innerText = str;
    //         console.log(77777,domList[index].innerText);
    //     })
    // }, 1000);
  },
  beforeDestroy() {
    //清除计时器
    // clearInterval(this.timer);
  },
  methods: {
    toMore() {
      sessionStorage.setItem("tabIndex", 7);
      this.$router.push("/project");
    },
    toDetail(id) {
      sessionStorage.setItem("tabIndex", 7);
      this.$router.push({
        path: "/projectDetail",
        query: {
          id,
        },
      });
    },
    limitNumber(txt, idName, num) {
      var str = txt;
      str = str.substr(0, num) + "...";
      var id = document.getElementById(idName);
      id.innerText = str;
    },
  },
};
</script>

<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.project {
  width: 100%;
  height: 961px;
  background: #f5f5f5;
  .project-i {
    width: 285px;
    height: 342px;
    background: #fff;
    margin-bottom: 30px;
    cursor: pointer;
    .project-i-t {
      width: 100%;
      padding-left: 10px;
      height: 16px;
      line-height: 16px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #333333;
      margin: 19px 0px 10px 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .project-i-txt {
      width: 100%;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #888888;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      min-height: 75px;
    }
  }
  .project-i:hover {
    box-shadow: 1px 20px 50px 0px rgba(207, 207, 207, 1);
  }
  .project-i:hover .project-i-t {
    color: #3476C1;
  }
  .morezanserve {
      margin: 10px auto 0;
      width: 150px;
      height: 40px;
      border: 1px solid #5fc0e4;
      border-radius: 3px;
      line-height: 40px;
      color: #5FC0E4;
      box-sizing: border-box;
      text-indent: 34px;
      background-image: url('../../static/common/morezan.png');
      background-size: 15px 15px;
      background-repeat: no-repeat;
      background-position: 101px 12px;
      cursor: pointer;
    }
    .morezanserve:hover {
    background-color: #5FC0E4;
    background-image: url('../../static/common/morezan1.png');
    color: #fff;
  }
}
</style>